import { render, staticRenderFns } from "./FocusMenu.vue?vue&type=template&id=71c46d25&scoped=true&"
import script from "./FocusMenu.vue?vue&type=script&lang=js&"
export * from "./FocusMenu.vue?vue&type=script&lang=js&"
import style0 from "./FocusMenu.vue?vue&type=style&index=0&id=71c46d25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c46d25",
  null
  
)

export default component.exports